import React from 'react';
import { FormattedMessage, FormattedNumber, useIntl } from 'react-intl';

import { Criticality, HighestOverdueOrigin } from '@/generated/GeneratedApiTypes';

const percentageDisplay = (value: number, tooltip: React.ReactElement | undefined) => {
    if (value > 0) {
        return (
            <div>
                <FormattedNumber value={value} minimumFractionDigits={0} maximumFractionDigits={2} />
                {PERCENTAGE_UNIT}
                {tooltip}
            </div>
        );
    } else {
        return <FormattedMessage id="intl-msg:maintenanceHistory.component.notOverdue" />;
    }
};

const timeDisplay = (value: number, tooltip: React.ReactElement | undefined, unit: string) => {
    if (value >= 60) {
        return (
            <div>
                <FormattedNumber value={value} minimumFractionDigits={0} maximumFractionDigits={0} />
                {unit}
                {tooltip}
            </div>
        );
    } else {
        return <FormattedMessage id="intl-msg:maintenanceHistory.component.notOverdue" />;
    }
};

const PERCENTAGE_UNIT = '%';
const DAYS_I18N = 'intl-msg:maintenanceHistory.days';

const EngineOilChangeOverdueStatusPanel = ({
    dataTestId,
    status,
    value,
    origin,
    titleI18n,
    tooltip,
    panelExtraClasses,
}: EngineOilChangeOverdueStatusPanelProps) => {
    const intl = useIntl();
    const daysTranslated = ' ' + intl.formatMessage({ id: DAYS_I18N });

    return (
        <div className={`col-xs-12 col-sm-6 col-md-6 display-flex ${panelExtraClasses}`}>
            <div
                // eslint-disable-next-line max-len
                className={`panel panel-default margin-bottom-0 width-100pct ${status === 'DANGER' ? 'status-critical' : 'status-ok'}`}
                data-testid={dataTestId}
            >
                <div className="panel-body">
                    <div className={'display-flex'}>
                        <span className={'text-size-14'}>
                            <FormattedMessage id={titleI18n} />
                        </span>
                    </div>
                    {origin === 'TIME'
                        ? timeDisplay(value, tooltip, daysTranslated)
                        : percentageDisplay(value, tooltip)}
                </div>
            </div>
        </div>
    );
};

interface EngineOilChangeOverdueStatusPanelProps {
    dataTestId: string;
    status: Criticality;
    value: number;
    percentageTimeAbove?: number;
    origin?: HighestOverdueOrigin;
    titleI18n: string;
    tooltip?: React.ReactElement;
    panelExtraClasses?: string;
}

export default EngineOilChangeOverdueStatusPanel;
